import script from "./IfrsCheckerPopUp.vue?vue&type=script&setup=true&lang=js"
export * from "./IfrsCheckerPopUp.vue?vue&type=script&setup=true&lang=js"

import "./IfrsCheckerPopUp.vue?vue&type=style&index=0&id=20d924b7&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-20d924b7"]])

export default __exports__